var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoctioLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 165.494,
    height: 39.428,
    viewBox: "0 0 165.494 39.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 165.494,
    height: 39.428,
    fill: "#1f7672"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8086",
    "data-name": "Path 8086",
    d: "M91.307,21.882A14,14,0,0,0,67.331,32.139,13.926,13.926,0,0,0,71.217,42.4a13.353,13.353,0,0,0,9.878,3.9A14.061,14.061,0,0,0,91.2,42.37a13.57,13.57,0,0,0,4.111-10.257,13.656,13.656,0,0,0-4.008-10.231M87,39.031a8.051,8.051,0,0,1-5.9,2.492,7.446,7.446,0,0,1-5.7-2.466,9.776,9.776,0,0,1-2.293-6.917,9.656,9.656,0,0,1,2.344-6.924,7.631,7.631,0,0,1,5.774-2.467,7.9,7.9,0,0,1,5.851,2.467,9.458,9.458,0,0,1,2.415,6.9A9.353,9.353,0,0,1,87,39.031",
    transform: "translate(-25.75 -6.873)",
    fill: "#1f7672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8087",
    "data-name": "Path 8087",
    d: "M132.129,41.522a6.823,6.823,0,0,1-5.549-2.492,10.5,10.5,0,0,1-2.068-6.917,10.415,10.415,0,0,1,2.068-6.9,6.859,6.859,0,0,1,5.549-2.467q4.981,0,6.519,4.335h6.127a11.675,11.675,0,0,0-4.406-6.75,13.7,13.7,0,0,0-8.24-2.363,12.887,12.887,0,0,0-9.685,3.886q-3.757,3.882-3.757,10.282a14.241,14.241,0,0,0,3.731,10.282,12.875,12.875,0,0,0,9.711,3.88,13.217,13.217,0,0,0,8.163-2.467,12.229,12.229,0,0,0,4.483-6.641h-6.127q-1.59,4.326-6.519,4.329",
    transform: "translate(-45.39 -6.873)",
    fill: "#1f7672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8088",
    "data-name": "Path 8088",
    d: "M181.379,19.106V14.475h-6.667V7.654h-5.729v6.821h-3.237v4.631h3.237V34.288q0,7.621,7.919,7.618h4.477V37.179H177.9a3.585,3.585,0,0,1-2.466-.674,2.9,2.9,0,0,1-.719-2.216V19.106Z",
    transform: "translate(-63.387 -2.927)",
    fill: "#1f7672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8089",
    "data-name": "Path 8089",
    d: "M203.9,39.377h5.678V11.946H203.9Zm5.427-37.29a3.66,3.66,0,0,0-5.125,0,3.51,3.51,0,0,0-1.047,2.588A3.5,3.5,0,0,0,204.2,7.263a3.66,3.66,0,0,0,5.125,0,3.5,3.5,0,0,0,1.047-2.588,3.51,3.51,0,0,0-1.047-2.588",
    transform: "translate(-77.694 -0.398)",
    fill: "#1f7672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8090",
    "data-name": "Path 8090",
    d: "M246.641,21.882a14,14,0,0,0-23.975,10.257A13.926,13.926,0,0,0,226.552,42.4a13.356,13.356,0,0,0,9.884,3.9,14.055,14.055,0,0,0,10.1-3.931,13.546,13.546,0,0,0,4.111-10.257,13.656,13.656,0,0,0-4.008-10.231m-4.309,17.149a8.036,8.036,0,0,1-5.9,2.492,7.469,7.469,0,0,1-5.7-2.466,9.776,9.776,0,0,1-2.293-6.917,9.656,9.656,0,0,1,2.344-6.924,7.64,7.64,0,0,1,5.774-2.467,7.887,7.887,0,0,1,5.851,2.467,9.458,9.458,0,0,1,2.415,6.9,9.326,9.326,0,0,1-2.492,6.917",
    transform: "translate(-85.155 -6.873)",
    fill: "#1f7672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8091",
    "data-name": "Path 8091",
    d: "M18.428,38.806H0V8.59H18.428a10.813,10.813,0,1,1,0,21.627H8.714v-17.3H4.323v21.57h14.1a15.08,15.08,0,0,0,0-30.16H13.037V6.4H8.714V0h9.714a19.4,19.4,0,0,1,0,38.806M13.037,25.893h5.391a6.49,6.49,0,1,0,0-12.981H13.037Z",
    transform: "translate(0 0)",
    fill: "#1f7672"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctioLogo);
export default __webpack_public_path__ + "static/media/doctio-logo.7f34301547fa2e726f386dc5bb8d3f3f.svg";
export { ForwardRef as ReactComponent };